// Neutral gray user silhouette avatar (inline SVG data URI — no network, no logo).
// Matches the app's muted palette (#9EABCE-ish on transparent). Works as <img src>.
import { API } from './api';

export const SILHOUETTE_AVATAR =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#1a2238"/>
          <stop offset="100%" stop-color="#0B112B"/>
        </linearGradient>
      </defs>
      <rect width="100" height="100" fill="url(#bg)"/>
      <circle cx="50" cy="38" r="16" fill="#3a4566"/>
      <path d="M18 92 C18 70 32 60 50 60 C68 60 82 70 82 92 Z" fill="#3a4566"/>
    </svg>`
  );

/**
 * Resolve a photo object to a renderable src URL.
 * Photos may come with either:
 *  - `url` — absolute URL (AI-seeded demo photos, legacy external hosts)
 *  - `storage_path` — backend-stored file, served at {API}/files/{path}
 * Falls back to the silhouette placeholder if neither is present.
 */
export function getPhotoSrc(photo) {
  if (!photo) return SILHOUETTE_AVATAR;
  if (photo.url) return photo.url;
  if (photo.storage_path) return `${API}/files/${photo.storage_path}`;
  return SILHOUETTE_AVATAR;
}

/** Returns the first photo's renderable src for a user, or the silhouette. */
export function getAvatarUrl(user) {
  return getPhotoSrc(user?.photos?.[0]);
}
